import { render, staticRenderFns } from "./AssignmentLibrary.vue?vue&type=template&id=c31dffa6&scoped=true&"
import script from "./AssignmentLibrary.vue?vue&type=script&lang=js&"
export * from "./AssignmentLibrary.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentLibrary.vue?vue&type=style&index=0&id=c31dffa6&lang=scss&scoped=true&"
import style1 from "./AssignmentLibrary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31dffa6",
  null
  
)

export default component.exports